// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"aw-z","response":"bw-z","error":"cw-z","disabled":"dw-z","buttons":"ew-z","feedbackQuestionSection":"fw-z","yesNoWrapper":"gw-z"};